import React from "react";
import { GuideCard, GuideContainer } from "./Guide.styled";
import img1 from "../../assets/d79364c0-e09d-459d-a6bd-e0df4a4d4513.jpg";
import img2 from "../../assets/image 5.png";
import img3 from "../../assets/image 6.png";
import img4 from "../../assets/image 7.png";
import img5 from "../../assets/image 8.png";
import img6 from "../../assets/image 9.png";
import img7 from "../../assets/image 10.png";
import img8 from "../../assets/image 11.png";
import img9 from "../../assets/image 12.png";
import img10 from "../../assets/image 13.png";
import img11 from "../../assets/image 14.png";
import img12 from "../../assets/image 15.png";
import img13 from "../../assets/image 16.png";
import img14 from "../../assets/image 17.png";

const Guide = () => {
  return (
    <GuideContainer>
      <GuideCard>
        {[
          {
            heading: "HOW TO DEPOSIT",
            content: (
              <>
                <p>
                  Use the "Deposit" option to fund your account. The deposit
                  currency is TRX (TRON). After deposit, proceed to purchase a
                  mining machine.
                </p>
                <img src={img1} alt="img1" />
                <p>
                  The deposit address is TRX. Copy or scan the QR Code and
                  deposit within the allocated time. After deposit, click on “I
                  HAVE PAID” and wait a few minutes for confirmation.
                </p>
                <img src={img2} alt="img2" />
                <img src={img3} alt="img3" />
              </>
            ),
          },
          {
            heading: "HOW TO PURCHASE A MINING MACHINE",
            content: (
              <>
                <p>
                  You can choose from a variety of machines with different hash
                  rates and prices. The more powerful the machine, the higher
                  your daily income will be.
                </p>
                <img src={img4} alt="img4" />
                <img src={img5} alt="img5" />
                <img src={img6} alt="img6" />
                <img src={img7} alt="img7" />
              </>
            ),
          },
          {
            heading: "HOW TO WITHDRAW",
            content: (
              <>
                <p>
                  Click on the withdrawal option and your earnings will be paid
                  directly to your TRON wallet. The minimum withdrawal amount is
                  50 TRX, and there is a withdrawal fee of 10% on every
                  withdrawals.
                </p>
                <img src={img8} alt="img8" />
                <p>
                  Set up your withdrawal address and withdrawal pin before
                  initiating withdrawal. Once set, you can initiate a withdrawal
                  anytime on the withdrawal days.
                </p>
                <img src={img8} alt="img8" />
                <img src={img9} alt="img9" />
                <img src={img10} alt="img10" />
                <img src={img11} alt="img11" />
              </>
            ),
          },
          {
            heading: "HOW TO SELL A MINING MACHINE",
            content: (
              <>
                <p>
                  Go to Miners Owned and select the mining machine you want to
                  sell. Select quantity and initiate sale. There's a 40% Sell
                  Fee on every machine.
                </p>
                <img src={img12} alt="img12" />
                <img src={img13} alt="img13" />
                <img src={img14} alt="img14" />
              </>
            ),
          },
        ].map((data, index, row) => (
          <React.Fragment key={index}>
            <h3 style={{ marginBlockStart: `${index === 0 ? "" : "50px"}` }}>
              {data.heading}
            </h3>
            {data.content}
          </React.Fragment>
        ))}
      </GuideCard>
    </GuideContainer>
  );
};

export default Guide;
